export default __webpack_public_path__ + "static/media/lib-template3.47d8c7e2.png";